import React from 'react';
import { LoginSignUpModal } from '@spotahome/ui-library';
import './LoginModalStyles';

import withModalProps from './withModalProps';

const LoginModal = ({ onClose, isOpen, modalProps }) => (
  <LoginSignUpModal {...modalProps} isOpen={isOpen} onClose={onClose} />
);

export default withModalProps()(LoginModal);
